import { ORDER_OBJECT_TAB } from '../orders.constants';
import { getOrderTabPath } from './orderTabPath.utils';
import { GetOrderTargetsTabPathParams } from './orderTargetsTab.types';

export const ORDER_TARGETS_TAB_EXPAND_PARAM = 'expandTarget';

export const getOrderTargetsTabPath = ({ orderId, targetId }: GetOrderTargetsTabPathParams) =>
  getOrderTabPath({
    orderId,
    tab: ORDER_OBJECT_TAB.TARGETS,
    params: targetId ? [[ORDER_TARGETS_TAB_EXPAND_PARAM, targetId]] : [],
  });

export const getExpandTargetParam = (searchParams: Record<string, unknown>): string | null => {
  const value = searchParams[ORDER_TARGETS_TAB_EXPAND_PARAM];

  return typeof value === 'string' && value ? value : null;
};
